import axios from 'axios'

const moment = require('moment')
require('moment/locale/pt-br')

export default {
	methods: {
		// Sincroniza os dados salvos no local storage com os dados locais do componente
		syncNPSConfig(identity = null) {
			this.$store.dispatch('NPS/syncNPSConfig', { nps_user_identity: identity })
			this.npsConfig = this.npsConfigStorage
		},

		async getNPSConfig(identity = null, userGroup = null, newRequest = false) {
			// It was loaded from local storage
			// Os dados já foram carregados do local storage, não é preciso fazer o request.
			if (this.npsConfig && !newRequest) return

			this.loader.load = true

			try {
				let { data } = await axios({
					method: 'get',
					url:
						process.env.VUE_APP_NPS_API_URL +
						'settings/public?fac_user_id=' +
						identity +
						'&fac_user_group=' +
						userGroup,
					headers: {
						'client-token': process.env.VUE_APP_NPS_API_TOKEN,
					},
				})

				// Add data to check if is closed later
				// Adiciona dados para fazer a verificação de closed futuramente
				if (!newRequest) {
					data['nps_closed'] = false
					data['nps_closed_reset_date'] = null
				} else {
					data['nps_closed'] = this.npsConfig['nps_closed']
					data['nps_closed_reset_date'] = this.npsConfig['nps_closed_reset_date']
				}

				// Add data to check if is time to make new request
				// Adiciona dados para fazer a verificação de fazer um novo request futuramente
				data['nps_last_request_date'] = moment(new Date()).format('DD/MM/YYYY HH:mm:ss')
				data['nps_next_request_date'] = moment(new Date())
					.add('24', 'hours')
					.format('DD/MM/YYYY HH:mm:ss')

				// Salvar informações únicas do usuário
				data['nps_user_identity'] = identity

				// Update new data
				// Atualiza os dados no local storage e localmente no componente
				this.updateNPSConfig(data)
			} catch {
				this.updateNPSConfig(null)
				throw new Error('Erro no nps, servidor não encontrado!')
			}

			this.loader.load = false
		},

		async sendNPSRate() {
			this.loader.load = true
			try {
				let navigationVersion = this.navigatorBrowser()

				const payload = {
					instance: this.getInstance(),
					product: 'b2b',
					platform: 'web',
					origin_url: this.originURL,
					score: this.selectedRate.value,
					comment: this.sendMessage,
					fac_user_id: this.userIdentity,
					fac_user_name: this.userName,
					fac_user_email: this.userEmail,
					fac_user_mobile: this.userMobile,
					fac_user_avatar: this.userAvatar,
					fac_user_group: this.userGroup,
					fac_user_sex: this.userSex,
					system: this.operationalSystem(),
					system_version: this.systemVersion(),
					memory: navigator.deviceMemory ? navigator.deviceMemory : null,
					internet_speed: navigator?.connection?.downlink ? navigator.connection.downlink : null,
					navigator: navigationVersion.browser,
					navigator_version: navigationVersion.version,
					screen: this.screen()
				}

				await axios({
					method: 'post',
					url: process.env.VUE_APP_NPS_API_URL + 'nps',
					data: payload,
					headers: {
						'client-token': process.env.VUE_APP_NPS_API_TOKEN,
					},
				})

				// Atualiza nps_show_to_user para false manualmente
				let toUpdate = Object.assign({}, this.npsConfig)
				toUpdate['nps_show_to_user'] = false

				// Update new data
				// Atualiza os dados no local storage e localmente no componente
				this.updateNPSConfig(toUpdate, false)

				// Show to user
				// Altera a view para a view finished
				this.setViewStage('finished')
			} catch (e) {
				console.error(e)
			}

			this.loader.load = false
		},
		//Olha a versão do Sistema operacional
		operationalSystem() {
			if (window.navigator.userAgent.indexOf("Windows")		 != -1) return "Windows";
			if (window.navigator.userAgent.indexOf("Mac")            != -1) return "Mac/iOS";
			if (window.navigator.userAgent.indexOf("Unix-like")      != -1) return "UNIX";
			if (window.navigator.userAgent.indexOf("Linux")          != -1) return "Linux";
			return 'Sistema Operacional desconhecido'
		},
		systemVersion() {
			if (window.navigator.userAgent.indexOf("Windows NT 10.0")!= -1) return "10";
			if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) return "8";
			if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) return "7";
			if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) return "Vista";
			if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) return "XP";
			if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) return "2000";
		
			const string = window.navigator.userAgent;
			const regex = /\((.*?)\)/g;
			const matches = string.match(regex);
			const items = matches.map(match => match.replace(/\(|\)/g, ''))
			if (items[0]) return items[0]
			return 'Versão não encontrada'
		},
		// olha o tipo de navegador e a versão
		navigatorBrowser() {
			let allBrowsers = [
				{ check:  navigator.userAgent.includes(' OPR/'), name: 'opera', sigla: 'OPR'},
				{ check: typeof InstallTrigger !== 'undefined', name: 'Firefox', sigla: 'Firefox'},
				{ check: navigator.vendor.includes('Apple Computer'), name: 'Safari', sigla: 'Safari'}, 
				{ check: /*@cc_on!@*/false || !!document.documentMode, name: 'IE', sigla: 'IE'},
				{ check: navigator.userAgent.includes('Edg'), name: 'Edge', sigla: 'Edg'},
				{ check: navigator.vendor.includes('Google') && !navigator.userAgent.includes(' OPR/') && !navigator.userAgent.includes('Edg'), name: 'Chrome', sigla: 'Chrome' }
			]
			let returnBrowser = allBrowsers.filter(browser =>  browser.check == true)
			let navigatorUsed = navigator.userAgent.split(' ').filter(browser => browser.includes(returnBrowser[0].sigla))
			let navigationVersion = navigatorUsed[0].split('/')
			return returnBrowser.length > 0 ? 
			{ browser: returnBrowser[0].name, version: navigationVersion[1] } : 
			{ browser: 'Navegador não identificado', version: 'Versão do navegador não identificado' }
		},
		//traz o tamanho da tela do usuário
		screen() {
			return `${window.screen.width} x ${window.screen.height}`
		},

		// Atualiza os dados no local storage e localmente no componente
		updateNPSConfig(payload, updateLocal = true) {
			if (updateLocal) this.npsConfig = payload
			this.$store.dispatch('NPS/setNPSConfig', payload)
		},

		close() {
			// Force close app
			// Fecha o app
			this.forceClose = true
		},

		finish() {
			// Formata novos dados.
			// Seta a variável nps_closed para true
			// Seta a variável nps_closed_reset_date. O Valor é definido pegando a data/hora atual + a hora definida na variável nps_force_reply_time
			let payload = Object.assign({}, this.npsConfig)
			payload['nps_closed'] = true
			payload['nps_closed_reset_date'] = moment(new Date())
				.add(this.npsConfig.nps_force_reply_time, 'hours')
				.format('DD/MM/YYYY HH:mm:ss')

			// Update new data
			// Atualiza os dados no local storage e localmente no componente
			this.updateNPSConfig(payload)
		},

		// Finaliza e fecha o app
		finishAndClose() {
			this.finish()
			this.close()
		},

		verifyClosed() {
			if (!this.npsConfig) return

			// Se o app não foi fechado anteriormente, não é preciso fazer a verificação.
			// Se o app foi fechado permanentemente, não é preciso fazer a verificação.
			if (!this.isClosed || this.isClosedPermanently) return

			const now = moment(new Date())
			const resetDate = moment(this.npsConfig.nps_closed_reset_date, 'DD/MM/YYYY HH:mm:ss')
			const duration = moment.duration(now.diff(resetDate)).asHours()

			// Its not time to reset yet
			// Ainda não é hora de fazer o reset
			if (duration < 0) return

			// Reset closed data
			// Reseta os dados relacionados ao closed app
			let payload = Object.assign({}, this.npsConfig)
			payload['nps_closed'] = false
			payload['nps_closed_reset_date'] = null

			// Update new data
			// Atualiza os dados no local storage e localmente no componente
			this.updateNPSConfig(payload)
		},

		// Observa a variável selectedRate. Verifica se foi selecionado uma nota e, então, passa
		// para view de adicionar um comentário
		async verifyNextRequest() {
			if (!this.npsConfig) return

			const now = moment(new Date())
			const nextRequestDate = moment(
				this.npsConfig.nps_next_request_date,
				'DD/MM/YYYY HH:mm:ss',
			)
			const duration = moment.duration(now.diff(nextRequestDate)).asHours()

			// Its not time to make new request yet
			// Ainda não é hora de fazer o novo request
			if (duration < 0) return

			// Make new request
			// Faz o novo request
			await this.getNPSConfig(this.userIdentity, this.userGroup, true)
		},
	},
}
